/**
 * -------------------------------------------------------
 * NOTE: This is a generated file, do not manually modify!
 * -------------------------------------------------------
 */
export var Brand = 'rgba(0, 120, 100, 1)';
export var Black = 'rgba(0, 0, 0, 1)';
export var White = 'rgba(255, 255, 255, 1)';
export var Arch = 'rgba(0, 145, 58, 1)';
export var Primary100 = 'rgba(233, 250, 242, 1)';
export var Primary200 = 'rgba(211, 235, 219, 1)';
export var Primary300 = 'rgba(111, 201, 147, 1)';
export var Primary400 = 'rgba(0, 145, 58, 1)';
export var Primary450 = 'rgba(0, 138, 55, 1)';
export var Primary500 = 'rgba(0, 126, 50, 1)';
export var Primary600 = 'rgba(0, 102, 46, 1)';
export var Primary700 = 'rgba(0, 78, 35, 1)';
export var Primary800 = 'rgba(2, 47, 21, 1)';
export var Accent1_100 = 'rgba(250, 242, 250, 1)';
export var Accent1_200 = 'rgba(237, 221, 237, 1)';
export var Accent1_300 = 'rgba(214, 154, 214, 1)';
export var Accent1_400 = 'rgba(181, 117, 183, 1)';
export var Accent1_500 = 'rgba(156, 82, 158, 1)';
export var Accent1_600 = 'rgba(128, 52, 129, 1)';
export var Accent1_700 = 'rgba(74, 21, 75, 1)';
export var Accent1_800 = 'rgba(40, 8, 41, 1)';
export var Accent2_100 = 'rgba(255, 244, 242, 1)';
export var Accent2_200 = 'rgba(255, 222, 214, 1)';
export var Accent2_300 = 'rgba(255, 172, 153, 1)';
export var Accent2_400 = 'rgba(209, 118, 97, 1)';
export var Accent2_500 = 'rgba(166, 93, 76, 1)';
export var Accent2_600 = 'rgba(134, 62, 45, 1)';
export var Accent2_700 = 'rgba(107, 37, 19, 1)';
export var Accent2_800 = 'rgba(66, 12, 0, 1)';
export var Gray100 = 'rgba(249, 249, 249, 1)';
export var Gray200 = 'rgba(244, 244, 244, 1)';
export var Gray250 = 'rgba(235, 235, 235, 1)';
export var Gray300 = 'rgba(221, 221, 221, 1)';
export var Gray400 = 'rgba(188, 188, 188, 1)';
export var Gray500 = 'rgba(143, 143, 143, 1)';
export var Gray600 = 'rgba(107, 107, 107, 1)';
export var Gray700 = 'rgba(79, 79, 79, 1)';
export var Gray800 = 'rgba(50, 50, 50, 1)';
export var Gray900 = 'rgba(21, 21, 21, 1)';
/** @deprecated */
export var Attention100 = 'rgba(253, 248, 237, 1)';
/** @deprecated */
export var Attention200 = 'rgba(239, 226, 199, 1)';
/** @deprecated */
export var Attention300 = 'rgba(214, 183, 116, 1)';
/** @deprecated */
export var Attention400 = 'rgba(187, 135, 23, 1)';
/** @deprecated */
export var Attention500 = 'rgba(149, 107, 16, 1)';
/** @deprecated */
export var Attention600 = 'rgba(112, 80, 9, 1)';
/** @deprecated */
export var Attention700 = 'rgba(85, 60, 6, 1)';
/** @deprecated */
export var Attention800 = 'rgba(57, 39, 2, 1)';
export var Warning100 = 'rgba(253, 248, 237, 1)';
export var Warning200 = 'rgba(239, 226, 199, 1)';
export var Warning300 = 'rgba(214, 183, 116, 1)';
export var Warning400 = 'rgba(187, 135, 23, 1)';
export var Warning500 = 'rgba(149, 107, 16, 1)';
export var Warning600 = 'rgba(112, 80, 9, 1)';
export var Warning700 = 'rgba(85, 60, 6, 1)';
export var Warning800 = 'rgba(57, 39, 2, 1)';
export var Error100 = 'rgba(252, 237, 237, 1)';
export var Error200 = 'rgba(252, 213, 213, 1)';
export var Error300 = 'rgba(248, 151, 151, 1)';
export var Error400 = 'rgba(243, 82, 82, 1)';
export var Error500 = 'rgba(194, 64, 64, 1)';
export var Error600 = 'rgba(145, 46, 46, 1)';
export var Error700 = 'rgba(108, 32, 32, 1)';
export var Error800 = 'rgba(71, 18, 18, 1)';
export var Info100 = 'rgba(230, 245, 255, 1)';
export var Info200 = 'rgba(194, 229, 251, 1)';
export var Info300 = 'rgba(102, 189, 244, 1)';
export var Info400 = 'rgba(0, 145, 237, 1)';
export var Info500 = 'rgba(0, 115, 190, 1)';
export var Info600 = 'rgba(0, 85, 143, 1)';
export var Info700 = 'rgba(0, 63, 107, 1)';
export var Info800 = 'rgba(0, 40, 71, 1)';
export var Success100 = 'rgba(238, 248, 239, 1)';
export var Success200 = 'rgba(211, 232, 212, 1)';
export var Success300 = 'rgba(145, 198, 148, 1)';
export var Success400 = 'rgba(72, 160, 76, 1)';
export var Success500 = 'rgba(56, 127, 59, 1)';
export var Success600 = 'rgba(40, 95, 42, 1)';
export var Success700 = 'rgba(28, 71, 30, 1)';
export var Success800 = 'rgba(16, 46, 17, 1)';
export var Additional1_100 = 'rgba(238, 250, 251, 1)';
export var Additional1_200 = 'rgba(180, 227, 230, 1)';
export var Additional1_300 = 'rgba(105, 198, 204, 1)';
export var Additional1_400 = 'rgba(5, 160, 170, 1)';
export var Additional1_500 = 'rgba(3, 128, 136, 1)';
export var Additional1_600 = 'rgba(2, 96, 102, 1)';
export var Additional1_700 = 'rgba(1, 72, 77, 1)';
export var Additional1_800 = 'rgba(0, 48, 51, 1)';
export var Additional2_100 = 'rgba(252, 241, 237, 1)';
export var Additional2_200 = 'rgba(247, 210, 196, 1)';
export var Additional2_300 = 'rgba(239, 164, 137, 1)';
export var Additional2_400 = 'rgba(228, 103, 59, 1)';
export var Additional2_500 = 'rgba(182, 81, 45, 1)';
export var Additional2_600 = 'rgba(137, 59, 31, 1)';
export var Additional2_700 = 'rgba(103, 43, 21, 1)';
export var Additional2_800 = 'rgba(68, 26, 10, 1)';
export var Additional3_100 = 'rgba(247, 245, 242, 1)';
export var Additional3_200 = 'rgba(229, 220, 209, 1)';
export var Additional3_300 = 'rgba(203, 184, 162, 1)';
export var Additional3_400 = 'rgba(169, 137, 100, 1)';
export var Additional3_500 = 'rgba(134, 108, 78, 1)';
export var Additional3_600 = 'rgba(100, 80, 57, 1)';
export var Additional3_700 = 'rgba(75, 59, 42, 1)';
export var Additional3_800 = 'rgba(50, 38, 26, 1)';
export var Additional4_100 = 'rgba(249, 241, 246, 1)';
export var Additional4_200 = 'rgba(246, 207, 230, 1)';
export var Additional4_300 = 'rgba(236, 158, 205, 1)';
export var Additional4_400 = 'rgba(223, 93, 171, 1)';
export var Additional4_500 = 'rgba(178, 73, 136, 1)';
export var Additional4_600 = 'rgba(134, 53, 101, 1)';
export var Additional4_700 = 'rgba(100, 38, 75, 1)';
export var Additional4_800 = 'rgba(66, 22, 48, 1)';
export var Additional5_100 = 'rgba(247, 247, 242, 1)';
export var Additional5_200 = 'rgba(221, 223, 207, 1)';
export var Additional5_300 = 'rgba(186, 191, 159, 1)';
export var Additional5_400 = 'rgba(140, 148, 95, 1)';
export var Additional5_500 = 'rgba(111, 117, 74, 1)';
export var Additional5_600 = 'rgba(82, 87, 54, 1)';
export var Additional5_700 = 'rgba(61, 65, 39, 1)';
export var Additional5_800 = 'rgba(40, 43, 24, 1)';
export var Additional6_100 = 'rgba(243, 242, 247, 1)';
export var Additional6_200 = 'rgba(220, 218, 244, 1)';
export var Additional6_300 = 'rgba(184, 180, 233, 1)';
export var Additional6_400 = 'rgba(136, 130, 218, 1)';
export var Additional6_500 = 'rgba(108, 103, 174, 1)';
export var Additional6_600 = 'rgba(80, 76, 131, 1)';
export var Additional6_700 = 'rgba(59, 55, 98, 1)';
export var Additional6_800 = 'rgba(37, 34, 64, 1)';
export var Additional7_100 = 'rgba(242, 248, 247, 1)';
export var Additional7_200 = 'rgba(204, 228, 224, 1)';
export var Additional7_300 = 'rgba(153, 201, 193, 1)';
export var Additional7_400 = 'rgba(51, 147, 131, 1)';
export var Additional7_500 = 'rgba(0, 120, 100, 1)';
export var Additional7_600 = 'rgba(0, 96, 80, 1)';
export var Additional7_700 = 'rgba(0, 78, 65, 1)';
export var Additional7_800 = 'rgba(0, 60, 50, 1)';
export var BrandHex = '#007864';
export var BlackHex = '#000000';
export var WhiteHex = '#FFFFFF';
export var ArchHex = '#00913A';
export var Primary100Hex = '#E9FAF2';
export var Primary200Hex = '#D3EBDB';
export var Primary300Hex = '#6FC993';
export var Primary400Hex = '#00913A';
export var Primary450Hex = '#008A37';
export var Primary500Hex = '#007E32';
export var Primary600Hex = '#00662E';
export var Primary700Hex = '#004E23';
export var Primary800Hex = '#022F15';
export var Accent1_100Hex = '#FAF2FA';
export var Accent1_200Hex = '#EDDDED';
export var Accent1_300Hex = '#D69AD6';
export var Accent1_400Hex = '#B575B7';
export var Accent1_500Hex = '#9C529E';
export var Accent1_600Hex = '#803481';
export var Accent1_700Hex = '#4A154B';
export var Accent1_800Hex = '#280829';
export var Accent2_100Hex = '#FFF4F2';
export var Accent2_200Hex = '#FFDED6';
export var Accent2_300Hex = '#FFAC99';
export var Accent2_400Hex = '#D17661';
export var Accent2_500Hex = '#A65D4C';
export var Accent2_600Hex = '#863E2D';
export var Accent2_700Hex = '#6B2513';
export var Accent2_800Hex = '#420C00';
export var Gray100Hex = '#F9F9F9';
export var Gray200Hex = '#F4F4F4';
export var Gray250Hex = '#EBEBEB';
export var Gray300Hex = '#DDDDDD';
export var Gray400Hex = '#BCBCBC';
export var Gray500Hex = '#8F8F8F';
export var Gray600Hex = '#6B6B6B';
export var Gray700Hex = '#4F4F4F';
export var Gray800Hex = '#323232';
export var Gray900Hex = '#151515';
/** @deprecated */
export var Attention100Hex = '#FDF8ED';
/** @deprecated */
export var Attention200Hex = '#EFE2C7';
/** @deprecated */
export var Attention300Hex = '#D6B774';
/** @deprecated */
export var Attention400Hex = '#BB8717';
/** @deprecated */
export var Attention500Hex = '#956B10';
/** @deprecated */
export var Attention600Hex = '#705009';
/** @deprecated */
export var Attention700Hex = '#553C06';
/** @deprecated */
export var Attention800Hex = '#392702';
export var Warning100Hex = '#FDF8ED';
export var Warning200Hex = '#EFE2C7';
export var Warning300Hex = '#D6B774';
export var Warning400Hex = '#BB8717';
export var Warning500Hex = '#956B10';
export var Warning600Hex = '#705009';
export var Warning700Hex = '#553C06';
export var Warning800Hex = '#392702';
export var Error100Hex = '#FCEDED';
export var Error200Hex = '#FCD5D5';
export var Error300Hex = '#F89797';
export var Error400Hex = '#F35252';
export var Error500Hex = '#C24040';
export var Error600Hex = '#912E2E';
export var Error700Hex = '#6C2020';
export var Error800Hex = '#471212';
export var Info100Hex = '#E6F5FF';
export var Info200Hex = '#C2E5FB';
export var Info300Hex = '#66BDF4';
export var Info400Hex = '#0091ED';
export var Info500Hex = '#0073BE';
export var Info600Hex = '#00558F';
export var Info700Hex = '#003F6B';
export var Info800Hex = '#002847';
export var Success100Hex = '#EEF8EF';
export var Success200Hex = '#D3E8D4';
export var Success300Hex = '#91C694';
export var Success400Hex = '#48A04C';
export var Success500Hex = '#387F3B';
export var Success600Hex = '#285F2A';
export var Success700Hex = '#1C471E';
export var Success800Hex = '#102E11';
export var Additional1_100Hex = '#EEFAFB';
export var Additional1_200Hex = '#B4E3E6';
export var Additional1_300Hex = '#69C6CC';
export var Additional1_400Hex = '#05A0AA';
export var Additional1_500Hex = '#038088';
export var Additional1_600Hex = '#026066';
export var Additional1_700Hex = '#01484D';
export var Additional1_800Hex = '#003033';
export var Additional2_100Hex = '#FCF1ED';
export var Additional2_200Hex = '#F7D2C4';
export var Additional2_300Hex = '#EFA489';
export var Additional2_400Hex = '#E4673B';
export var Additional2_500Hex = '#B6512D';
export var Additional2_600Hex = '#893B1F';
export var Additional2_700Hex = '#672B15';
export var Additional2_800Hex = '#441A0A';
export var Additional3_100Hex = '#F7F5F2';
export var Additional3_200Hex = '#E5DCD1';
export var Additional3_300Hex = '#CBB8A2';
export var Additional3_400Hex = '#A98964';
export var Additional3_500Hex = '#866C4E';
export var Additional3_600Hex = '#645039';
export var Additional3_700Hex = '#4B3B2A';
export var Additional3_800Hex = '#32261A';
export var Additional4_100Hex = '#F9F1F6';
export var Additional4_200Hex = '#F6CFE6';
export var Additional4_300Hex = '#EC9ECD';
export var Additional4_400Hex = '#DF5DAB';
export var Additional4_500Hex = '#B24988';
export var Additional4_600Hex = '#863565';
export var Additional4_700Hex = '#64264B';
export var Additional4_800Hex = '#421630';
export var Additional5_100Hex = '#F7F7F2';
export var Additional5_200Hex = '#DDDFCF';
export var Additional5_300Hex = '#BABF9F';
export var Additional5_400Hex = '#8C945F';
export var Additional5_500Hex = '#6F754A';
export var Additional5_600Hex = '#525736';
export var Additional5_700Hex = '#3D4127';
export var Additional5_800Hex = '#282B18';
export var Additional6_100Hex = '#F3F2F7';
export var Additional6_200Hex = '#DCDAF4';
export var Additional6_300Hex = '#B8B4E9';
export var Additional6_400Hex = '#8882DA';
export var Additional6_500Hex = '#6C67AE';
export var Additional6_600Hex = '#504C83';
export var Additional6_700Hex = '#3B3762';
export var Additional6_800Hex = '#252240';
export var Additional7_100Hex = '#F2F8F7';
export var Additional7_200Hex = '#CCE4E0';
export var Additional7_300Hex = '#99C9C1';
export var Additional7_400Hex = '#339383';
export var Additional7_500Hex = '#007864';
export var Additional7_600Hex = '#006050';
export var Additional7_700Hex = '#004E41';
export var Additional7_800Hex = '#003C32';
export var Primary = {
    '100': 'rgba(233, 250, 242, 1)',
    '200': 'rgba(211, 235, 219, 1)',
    '300': 'rgba(111, 201, 147, 1)',
    '400': 'rgba(0, 145, 58, 1)',
    '450': 'rgba(0, 138, 55, 1)',
    '500': 'rgba(0, 126, 50, 1)',
    '600': 'rgba(0, 102, 46, 1)',
    '700': 'rgba(0, 78, 35, 1)',
    '800': 'rgba(2, 47, 21, 1)',
};
export var Accent1 = {
    '100': 'rgba(250, 242, 250, 1)',
    '200': 'rgba(237, 221, 237, 1)',
    '300': 'rgba(214, 154, 214, 1)',
    '400': 'rgba(181, 117, 183, 1)',
    '500': 'rgba(156, 82, 158, 1)',
    '600': 'rgba(128, 52, 129, 1)',
    '700': 'rgba(74, 21, 75, 1)',
    '800': 'rgba(40, 8, 41, 1)',
};
export var Accent2 = {
    '100': 'rgba(255, 244, 242, 1)',
    '200': 'rgba(255, 222, 214, 1)',
    '300': 'rgba(255, 172, 153, 1)',
    '400': 'rgba(209, 118, 97, 1)',
    '500': 'rgba(166, 93, 76, 1)',
    '600': 'rgba(134, 62, 45, 1)',
    '700': 'rgba(107, 37, 19, 1)',
    '800': 'rgba(66, 12, 0, 1)',
};
export var Gray = {
    '100': 'rgba(249, 249, 249, 1)',
    '200': 'rgba(244, 244, 244, 1)',
    '250': 'rgba(235, 235, 235, 1)',
    '300': 'rgba(221, 221, 221, 1)',
    '400': 'rgba(188, 188, 188, 1)',
    '500': 'rgba(143, 143, 143, 1)',
    '600': 'rgba(107, 107, 107, 1)',
    '700': 'rgba(79, 79, 79, 1)',
    '800': 'rgba(50, 50, 50, 1)',
    '900': 'rgba(21, 21, 21, 1)',
};
/** @deprecated */
export var Attention = {
    '100': 'rgba(253, 248, 237, 1)',
    '200': 'rgba(239, 226, 199, 1)',
    '300': 'rgba(214, 183, 116, 1)',
    '400': 'rgba(187, 135, 23, 1)',
    '500': 'rgba(149, 107, 16, 1)',
    '600': 'rgba(112, 80, 9, 1)',
    '700': 'rgba(85, 60, 6, 1)',
    '800': 'rgba(57, 39, 2, 1)',
};
export var Warning = {
    '100': 'rgba(253, 248, 237, 1)',
    '200': 'rgba(239, 226, 199, 1)',
    '300': 'rgba(214, 183, 116, 1)',
    '400': 'rgba(187, 135, 23, 1)',
    '500': 'rgba(149, 107, 16, 1)',
    '600': 'rgba(112, 80, 9, 1)',
    '700': 'rgba(85, 60, 6, 1)',
    '800': 'rgba(57, 39, 2, 1)',
};
export var Error = {
    '100': 'rgba(252, 237, 237, 1)',
    '200': 'rgba(252, 213, 213, 1)',
    '300': 'rgba(248, 151, 151, 1)',
    '400': 'rgba(243, 82, 82, 1)',
    '500': 'rgba(194, 64, 64, 1)',
    '600': 'rgba(145, 46, 46, 1)',
    '700': 'rgba(108, 32, 32, 1)',
    '800': 'rgba(71, 18, 18, 1)',
};
export var Info = {
    '100': 'rgba(230, 245, 255, 1)',
    '200': 'rgba(194, 229, 251, 1)',
    '300': 'rgba(102, 189, 244, 1)',
    '400': 'rgba(0, 145, 237, 1)',
    '500': 'rgba(0, 115, 190, 1)',
    '600': 'rgba(0, 85, 143, 1)',
    '700': 'rgba(0, 63, 107, 1)',
    '800': 'rgba(0, 40, 71, 1)',
};
export var Success = {
    '100': 'rgba(238, 248, 239, 1)',
    '200': 'rgba(211, 232, 212, 1)',
    '300': 'rgba(145, 198, 148, 1)',
    '400': 'rgba(72, 160, 76, 1)',
    '500': 'rgba(56, 127, 59, 1)',
    '600': 'rgba(40, 95, 42, 1)',
    '700': 'rgba(28, 71, 30, 1)',
    '800': 'rgba(16, 46, 17, 1)',
};
export var Additional1 = {
    '100': 'rgba(238, 250, 251, 1)',
    '200': 'rgba(180, 227, 230, 1)',
    '300': 'rgba(105, 198, 204, 1)',
    '400': 'rgba(5, 160, 170, 1)',
    '500': 'rgba(3, 128, 136, 1)',
    '600': 'rgba(2, 96, 102, 1)',
    '700': 'rgba(1, 72, 77, 1)',
    '800': 'rgba(0, 48, 51, 1)',
};
export var Additional2 = {
    '100': 'rgba(252, 241, 237, 1)',
    '200': 'rgba(247, 210, 196, 1)',
    '300': 'rgba(239, 164, 137, 1)',
    '400': 'rgba(228, 103, 59, 1)',
    '500': 'rgba(182, 81, 45, 1)',
    '600': 'rgba(137, 59, 31, 1)',
    '700': 'rgba(103, 43, 21, 1)',
    '800': 'rgba(68, 26, 10, 1)',
};
export var Additional3 = {
    '100': 'rgba(247, 245, 242, 1)',
    '200': 'rgba(229, 220, 209, 1)',
    '300': 'rgba(203, 184, 162, 1)',
    '400': 'rgba(169, 137, 100, 1)',
    '500': 'rgba(134, 108, 78, 1)',
    '600': 'rgba(100, 80, 57, 1)',
    '700': 'rgba(75, 59, 42, 1)',
    '800': 'rgba(50, 38, 26, 1)',
};
export var Additional4 = {
    '100': 'rgba(249, 241, 246, 1)',
    '200': 'rgba(246, 207, 230, 1)',
    '300': 'rgba(236, 158, 205, 1)',
    '400': 'rgba(223, 93, 171, 1)',
    '500': 'rgba(178, 73, 136, 1)',
    '600': 'rgba(134, 53, 101, 1)',
    '700': 'rgba(100, 38, 75, 1)',
    '800': 'rgba(66, 22, 48, 1)',
};
export var Additional5 = {
    '100': 'rgba(247, 247, 242, 1)',
    '200': 'rgba(221, 223, 207, 1)',
    '300': 'rgba(186, 191, 159, 1)',
    '400': 'rgba(140, 148, 95, 1)',
    '500': 'rgba(111, 117, 74, 1)',
    '600': 'rgba(82, 87, 54, 1)',
    '700': 'rgba(61, 65, 39, 1)',
    '800': 'rgba(40, 43, 24, 1)',
};
export var Additional6 = {
    '100': 'rgba(243, 242, 247, 1)',
    '200': 'rgba(220, 218, 244, 1)',
    '300': 'rgba(184, 180, 233, 1)',
    '400': 'rgba(136, 130, 218, 1)',
    '500': 'rgba(108, 103, 174, 1)',
    '600': 'rgba(80, 76, 131, 1)',
    '700': 'rgba(59, 55, 98, 1)',
    '800': 'rgba(37, 34, 64, 1)',
};
export var Additional7 = {
    '100': 'rgba(242, 248, 247, 1)',
    '200': 'rgba(204, 228, 224, 1)',
    '300': 'rgba(153, 201, 193, 1)',
    '400': 'rgba(51, 147, 131, 1)',
    '500': 'rgba(0, 120, 100, 1)',
    '600': 'rgba(0, 96, 80, 1)',
    '700': 'rgba(0, 78, 65, 1)',
    '800': 'rgba(0, 60, 50, 1)',
};
